/* import __COLOCATED_TEMPLATE__ from './company-profile-postings.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { showModal } from 'sh-www/utils/modal-controls';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-company-profile-postings';

class CompanyProfilePostings extends Component {
  @service('commands/assignment-commands') assignmentCommandService;
  @service router;
  @service session;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      'LSG-l-container-page--small-and-down-full-width-child',
    );
  }

  /**
   * @param {Assignment} assignment
   */
  @action
  showFeedback(assignment) {
    if (this.setNotInterested.isRunning) return;

    const notInterested = assignment.assignmentUserMeta?.notInterested;
    if (notInterested || !assignment.allowSellerFeedback) {
      this.setNotInterested.perform(assignment, !notInterested);
    } else {
      showModal(this, 'posting-feedback', {
        assignment,
      });
    }
  }

  /**
   * @param {Assignment} assignment
   * @param {boolean} favorite
   */
  @action
  setFavorite(assignment, favorite) {
    return this.assignmentCommandService.setFavorite(assignment, this.session.currentUser.id, favorite);
  }

  /**
   * @param {Assignment} assignment
   * @param {boolean} favorite
   */
  @action
  viewPosting(assignment) {
    return this.router.transitionTo(EMBER_ROUTE_NAMES.POSTING__INDEX, assignment.idWithSlug);
  }

  /**
   * @param {Assignment} assignment
   * @param {boolean} notInterested
   */
  @task
  *setNotInterested(assignment, notInterested) {
    yield this.assignmentCommandService.setNotInterested(assignment, this.session.currentUser.id, {}, notInterested);
  }
}

export default CompanyProfilePostings;
